import Cookies from "js-cookie";
import { getHistoricalCallsCF, getHistoricalPlCF, getHistoricalPlPercentageCF, getHistoricalSRCF, getHistoricalTradesCF, getMtmDrawdownCF, getTargetSLCF } from "../../api/historicalEndPoints/commodityFutIntraday"
import { getHistoricalCallsES, getHistoricalPlES, getHistoricalPlPercentageES, getHistoricalSRES, getHistoricalTradesES, getMtmDrawdownES, getTargetSlES } from "../../api/historicalEndPoints/equitySpotMultiday"
import { getHistoricalCallsIF, getHistoricalMtmDrawdownIF, getHistoricalPlIF, getHistoricalPlPercentageIF, getHistoricalSRIF, getHistoricalTargetSlIF, getHistoricalTradesIF } from "../../api/historicalEndPoints/indexFutIntraday";
import { getHistoricalCallsIO, getHistoricalPlIO, getHistoricalPlPercentageIO, getHistoricalSRIO, getHistoricalTradesIO, getMtmDrawdownIO, getTargetSlIO } from "../../api/historicalEndPoints/indexOptIntraday";
import { getHistoricalCallsSF, getHistoricalMtmDrawdownSF, getHistoricalPlPercentageSF, getHistoricalPlSF, getHistoricalSRSF, getHistoricalTargetSlSF, getHistoricalTradesSF } from "../../api/historicalEndPoints/stockFutIntraday";
import { getHistoricalCallsPTI, getHistoricalPlPTI, getHistoricalPlPercentagePTI, getHistoricalSRPTI, getHistoricalTradesPTI, getMtmDrawdownPTI, getTargetSlPTI } from "../../api/historicalEndPoints/stockPairIntraday";

export const getPLPercentageResponse: any = async (startDate: any, endDate: any, asset: any, version: any, type: any, tradetype: any, filterDropdownVersion: any, returnType: any) => {
    let response: any = [];

    let formattedType: any = (type === asset) ? type : asset
    if (type === 'commodityFutIntraday') {
        response = await getHistoricalPlPercentageCF(startDate, endDate, formattedType, version, filterDropdownVersion)
    }
    else if (type==='equityMultiday') {
        response = await getHistoricalPlPercentageES(startDate, endDate, formattedType, version, filterDropdownVersion, returnType)
    }
    else if (type==='equityN50BANK') {
        response = await getHistoricalPlPercentageES(startDate, endDate, formattedType, version, filterDropdownVersion, returnType)
    }
    else if (type === 'stockFutIntraday') {
        response = await getHistoricalPlPercentageSF(startDate, endDate, formattedType, version, filterDropdownVersion)
    }
    else if (type === 'stockIndexFutIntraday') {
        response = await getHistoricalPlPercentageIF(startDate, endDate, formattedType, version, filterDropdownVersion)
    }
    else if (type === 'stockindexOptIntraday') {
        tradetype = 'short'
        response = await getHistoricalPlPercentageIO(startDate, endDate, version, tradetype, formattedType, filterDropdownVersion)
    }
    else if (type === 'stockOptIntraday') {
        tradetype = 'short'
        response = await getHistoricalPlPercentageIO(startDate, endDate, version, tradetype, formattedType, filterDropdownVersion)
    }
    else if (type === 'stockPairIntraday') {
        response = await getHistoricalPlPercentagePTI(startDate, endDate, version, tradetype, asset, filterDropdownVersion)
    }
    return response;
}

export const getCallsResponse: any = async (startDate: any, endDate: any, asset: any, version: any, type: any, tradetype: any, filterDropdownVersion: any) => {

 let callsResponse: any = {};
 let response: any = { total: '0', data: [] };
 if (type === 'commodityFutIntraday') {
 response = await getHistoricalCallsCF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type==='equityMultiday') {
 response = await getHistoricalCallsES(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type==='equityN50NXT') {
    response = await getHistoricalCallsES(startDate, endDate, asset, version, filterDropdownVersion)
    }
else if (type==='equityN50BANK') {
response = await getHistoricalCallsES(startDate, endDate, asset, version, filterDropdownVersion)
}
 else if (type === 'stockFutIntraday') {
 response = await getHistoricalCallsSF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type === 'stockIndexFutIntraday') {
 response = await getHistoricalCallsIF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type === 'stockindexOptIntraday') {
 let asset_: any = (version === 'all') ? asset : (asset.split('-'))?.length > 1 ? asset.split('-')[0] + '-'+asset.split('-')[1] : asset?.slice(0, -5)
 response = await getHistoricalCallsIO(startDate, endDate, version, tradetype, asset_, filterDropdownVersion)
 }
 else if (type === 'stockOptIntraday') {
 let asset_: any = (version === 'all') ? asset : asset?.slice(0, -6)
 response = await getHistoricalCallsIO(startDate, endDate, version, tradetype, asset_, filterDropdownVersion)
 }
 else if (type === 'stockPairIntraday') {
 response = await getHistoricalCallsPTI(startDate, endDate,version, tradetype, asset, filterDropdownVersion)
 }

 callsResponse['total'] = response?.total;
 callsResponse['data'] = response?.data;

 return callsResponse;
}


export const getSRResponse: any = async (startDate: any, endDate: any, asset: any, version: any, type: any, tradetype: any, filterDropdownVersion: any) => {
 let srResponse: any = {};
 let response: any = { total: '0', data: [] };
 if (type === 'commodityFutIntraday') {
 response = await getHistoricalSRCF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type==='equityMultiday') {
 response = await getHistoricalSRES(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type==='equityN50BANK') {
    response = await getHistoricalSRES(startDate, endDate, asset, version, filterDropdownVersion)
    }
 else if (type === 'stockFutIntraday') {
 response = await getHistoricalSRSF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type === 'stockIndexFutIntraday') {
 response = await getHistoricalSRIF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type === 'stockindexOptIntraday') {
 let asset_: any = (version === 'all') ? asset : (asset.split('-'))?.length > 1 ? asset.split('-')[0] + '-'+asset.split('-')[1] : asset?.slice(0, -5)
 response = await getHistoricalSRIO(startDate, endDate, version, tradetype, asset_, filterDropdownVersion)
 }
 else if (type === 'stockOptIntraday') {
 let asset_: any = (version === 'all') ? asset : asset?.slice(0, -6)
 response = await getHistoricalSRIO(startDate, endDate, version, tradetype, asset_, filterDropdownVersion)
 }
 else if (type === 'stockPairIntraday') {
 response = await getHistoricalSRPTI(startDate, endDate,version, tradetype, asset, filterDropdownVersion)
 }

 srResponse['total'] = response?.total;
 srResponse['data'] = response?.data;

 return srResponse;
}


export const getPLResponse: any = async (startDate: any, endDate: any, asset: any, version: any, type: any, tradetype: any, filterDropdownVersion: any) => {

 let plResponse: any = {};
 let response: any = { total: '0', data: [] };
 if (type === 'commodityFutIntraday') {
 response = await getHistoricalPlCF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type==='equityMultiday') {
 response = await getHistoricalPlES(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type==='equityN50BANK') {
    response = await getHistoricalPlES(startDate, endDate, asset, version, filterDropdownVersion)
    }
 else if (type === 'stockFutIntraday') {
 response = await getHistoricalPlSF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type === 'stockIndexFutIntraday') {
 response = await getHistoricalPlIF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type === 'stockindexOptIntraday') {
 let asset_: any = (version === 'all') ? asset : (asset.split('-'))?.length > 1 ? asset.split('-')[0] + '-'+asset.split('-')[1] : asset?.slice(0, -5)  //: asset?.slice(0, -5)
 response = await getHistoricalPlIO(startDate, endDate, version, tradetype, asset_, filterDropdownVersion)
 }
 else if (type === 'stockOptIntraday') {
 let asset_: any = (version === 'all') ? asset : asset?.slice(0, -6)
 response = await getHistoricalPlIO(startDate, endDate, version, tradetype, asset_, filterDropdownVersion)
 }
 else if (type === 'stockPairIntraday') {
 response = await getHistoricalPlPTI(startDate, endDate,version, tradetype, asset, filterDropdownVersion)
 }
 

 plResponse['total'] = response?.total;
 plResponse['data'] = response?.data;

 return plResponse;
}

export const getTradesResponse: any = async (type: any, startDate: any, endDate: any, version: any, tradetype: any, asset: any, filterDropdownVersion: any) => {
 
    let response: any = []
 if (type === 'commodityFutIntraday') {
 response = await getHistoricalTradesCF(startDate, endDate, asset, version, filterDropdownVersion)

 }
 else if (type==='equityMultiday') {
 response = await getHistoricalTradesES(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if (type==='equityN50BANK') {
    response = await getHistoricalTradesES(startDate, endDate, asset, version, filterDropdownVersion)
    }
 else if (type === 'stockFutIntraday') {
 response = await getHistoricalTradesSF(startDate, endDate, 'intraday-stock-future', version, filterDropdownVersion)
 }
 else if (type === 'stockIndexFutIntraday') {
 response = await getHistoricalTradesIF(startDate, endDate, asset, version, filterDropdownVersion)
 }
 else if ((type === 'stockindexOptIntraday')) {
 let asset_: any = (version === 'all') ? asset : (asset.split('-'))?.length > 1 ? asset.split('-')[0] + '-'+asset.split('-')[1] : asset?.slice(0, -5)

 response = await getHistoricalTradesIO(startDate, endDate, version, tradetype, asset_, filterDropdownVersion)
 }
 else if ((type === 'stockOptIntraday')) {
 let asset_: any = (version === 'all') ? asset : asset?.slice(0, -6)


 response = await getHistoricalTradesIO(startDate, endDate, version, tradetype, asset_, filterDropdownVersion)
 }
 else if (type === 'stockPairIntraday') {
 response = await getHistoricalTradesPTI(startDate, endDate,version, tradetype, asset, filterDropdownVersion)
 }

 return response
}

export const getTargetSlResponse: any = async (type: any, id: any, asset: any, version: any, date: any, tradetype: any) => {

 let response: any = []
 if (type === 'commodityFutIntraday') {
 response = await getTargetSLCF(id, asset, version, date, tradetype)
 }
 else if (type==='equityMultiday') {
 response = await getTargetSlES(id, asset, version, date)
 }
 else if (type==='equityN50BANK') {
    response = await getTargetSlES(id, asset, version, date)
    }
 else if (type === 'stockFutIntraday') {
 response = await getHistoricalTargetSlSF(id, asset, date, version)
 }
 else if (type === 'stockIndexFutIntraday') {
 response = await getHistoricalTargetSlIF(id, asset, date, version)
 }
 else if (type === 'stockindexOptIntraday') {
 response = await getTargetSlIO(date, asset, id, version, tradetype)
 }
 else if (type === 'stockOptIntraday') {
 response = await getTargetSlIO(date, asset, id, version, tradetype)
 }
 else if (type === 'stockPairIntraday') {
 response = await getTargetSlPTI(date, asset, id, version,tradetype)
 }

 return response
}


export const getM2mDrawdownResponse: any = async (type: any, id: any, asset: any, date: any, version: any) => {

 let response: any = []

 if (type === 'commodityFutIntraday') {
 response = getMtmDrawdownCF(id, asset, date, version)
 }
 else if (type==='equityMultiday') {
 response = getMtmDrawdownES(id, asset, version, date)
 }
 else if (type==='equityN50BANK') {
    response = getMtmDrawdownES(id, asset, version, date)
    }
 else if (type === 'stockFutIntraday') {
 response = await getHistoricalMtmDrawdownSF(id, asset, date, version)
 }
 else if (type === 'stockIndexFutIntraday') {
 response = await getHistoricalMtmDrawdownIF(id, asset, date, version)
 }
 else if (type === 'stockindexOptIntraday') {
 response = await getMtmDrawdownIO(date, asset, id, version)
 }
 else if (type === 'stockOptIntraday') {
 response = await getMtmDrawdownIO(date, asset, id, version)
 }
 else if (type === 'stockPairIntraday') {
 response = await getMtmDrawdownPTI(date, asset, id, version)
 }


 return response
}


export const handleVersion = (type: any) => {

 const cookiesPrivilege: any = Cookies.get('codesArray');
 const privilegeArray: any = Cookies.get('codesArray') ? JSON.parse(cookiesPrivilege) : []

 let obj: any = Object.freeze({
 'commodityFutIntraday': 'CFI',
 'equityMultiday': 'ESM',
 'equityN50BANK':'EBM',
 'forexFutIntraday': 'FFI',
 'forexFutMultiday': 'FFM',
 'forexOptIntraday': 'FOI',
 'stockFutIntraday': 'SFI',
 'stockIndexFutIntraday': 'IFI',
 'stockindexOptIntraday': 'IOI',
 'stockOptIntraday': 'SOI',
 'backoffice': 'BACKOFFICE',
 'portfolio': 'PORTFOLIO'
 })

 let filteredArray: any = privilegeArray.filter((item: any, index: any) => {
    
    if (obj[type] === (item.slice(0,3)==='EBM'?item.slice(0,3):(item).slice(1, 3) + String(item.split('-')[0]).charAt((item.split('-')[0]).length - 1))) {
        return item.slice(0, 3) + item.slice(6, 9)
    }
 })

 return filteredArray
}

export function getSentimentChartColor(data: any, type: string) {
 if (type === 'bg') {
 if (Number(data[0]) > Number(data[data.length - 1])) {
 return 'rgb(230,0,0)'
 }
 else if (Number(data[0]) === Number(data[data.length - 1])) {
 return '#ffbb00'
 }
 else if (Number(data[0]) < Number(data[data.length - 1])) {
 return 'rgb(0,102,0)'
 }
 }
}